<template>
	<div id="app">
		<router-view></router-view>
	</div>
	
</template>
<script>
	
	export default {
		data() {
			return {
				
			}


		},
		created() {
			
		},
		methods: {
			
		}
	}
</script>
<style>
	* {
		margin: 0;
		padding: 0;
	}
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		font-size: 28px;
		background-color: #f5f5f5;
		height: 100%;
	}

	
</style>
